import React, { Component } from 'react'
import { Input } from '@driftt/tide-core'

class NumericInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentValue: props.value || 0
    }
  }

  handleChange = ({target: { value }}) => {
    const { onChange } = this.props

    this.setState({
      currentValue: Number(value)
    })

    onChange(Number(value))
  }

  render() {
    const { currentValue } = this.state
    return (
      <Input
        className="contact-details--typed-input--string"
        onChange={this.handleChange}
        value={currentValue}
        placeholder={'Select a number…'}
        type="number"
      />
    )
  }
}

export default NumericInput
